import * as z from "zod";
import { ONBOARDING_V2_STATUSES, PRODUCT_IDS } from "./initialize";

export const getResumeState = {
  name: "getResumeState" as const,
  input: z.object({ productId: z.enum(PRODUCT_IDS) }),
  output: z
    .object({
      status: z.enum(ONBOARDING_V2_STATUSES),
      currentStepId: z.string(),
      completedSteps: z.number().int().nonnegative(),
      totalSteps: z.number().int().positive(),
    })
    .nullable(),
};
